const back_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence reviewed",
         number: "0"
      },
      "maxLength":2000,
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
         "question":"ROM Measurements After Repetitive Use Testing",
         "sub":"",
         "type":"text",
         "show": true,
         "section": {
            page: "4",
            title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
            number: "3A"
         },
         "questions":[
            {
               "main":"Forward Flexion",
               "subMain":"Normal Endpoint is 90 Degrees",
               "sub":"Post-Test ROM Measurement",
               "video": "/imgs/app/rom-videos/back/back_forward flexion.mp4",
               "type":"select",
               "dbqName":"form1[0].#subform[6].ROM1b3b[0]",
               "defaultVal":"90",
               "values":[ "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5" ],
               "answer":"90"
            },
            {
               "main":"Right Lateral Flexion",
               "subMain":"Normal Endpoint is 30 Degrees",
               "sub":"Post-Test ROM Measurement",
               "video": "/imgs/app/rom-videos/back/back_right lateral flexion.mp4",
               "type":"select",
               "dbqName":"form1[0].#subform[6].ROM3b3b[0]",
               "defaultVal":"30",
               "values":[ "30", "25", "20", "15", "10", "5"],
               "answer":"30"
            },
            {
               "main":"Right Lateral Rotation",
               "subMain":"Normal Endpoint is 30 Degrees",
               "sub":"Post-Test ROM Measurement",
               "video": "/imgs/app/rom-videos/back/back_right lateral rotation.mp4",
               "type":"select",
               "dbqName":"form1[0].#subform[6].ROM5b3b[0]",
               "defaultVal":"30",
               "values":[ "30", "25", "20", "15", "10", "5"],
               "answer":"30"
            },
            {
               "main":"Extension",
               "subMain":"Normal Endpoint is 30 Degrees",
               "sub":"Post-Test ROM Measurement",
               "video": "/imgs/app/rom-videos/back/back_extension.mp4",
               "type":"select",
               "dbqName":"form1[0].#subform[6].ROM2b3b[0]",
               "defaultVal":"30",
               "values":[ "30", "25", "20", "15", "10", "5"],
               "answer":"30"
            },
            {
               "main":"Left Lateral Flexion",
               "subMain":"Normal Endpoint is 30 Degrees",
               "sub":"Post-Test ROM Measurement",
               "video": "/imgs/app/rom-videos/back/back_left lateral flexion.mp4",
               "type":"select",
               "dbqName":"form1[0].#subform[6].ROM4b3b[0]",
               "defaultVal":"30",
               "values":[ "30", "25", "20", "15", "10", "5"],
               "answer":"30"
            },
            {
               "main":"Left Lateral Rotation",
               "subMain":"Normal Endpoint is 30 Degrees",
               "sub":"Post-Test ROM Measurement",
               "video": "/imgs/app/rom-videos/back/back_left lateral rotation.mp4",
               "type":"select",
               "dbqName":"form1[0].#subform[6].ROM6b3b[0]",
               "defaultVal":"30",
               "values":[ "30", "25", "20", "15", "10", "5"],
               "answer":"30"
            }
         ]
   },
   {
      "question":"Which ROM exhibited pain? ",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "optional": true,
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Forward Flexion",
            "dbqName":"form1[0].#subform[6].Right_DorsiflexionPain3b[0]",
            "answer":""
         },
         {
            "main":"Right Lateral Flexion",
            "dbqName":"form1[0].#subform[6].Right_ExternalPain3b[0]",
            "answer":""
         },
         {
            "main":"Right Lateral Rotation",
            "dbqName":"form1[0].#subform[6].Right_ExternalRotation3b[0]",
            "answer":""
         },
         {
            "main":"Extension",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain3b[0]",
            "answer":""
         },
         {
            "main":"Left Lateral Flexion",
            "dbqName":"form1[0].#subform[6].Right_InternalPain3b[0]",
            "answer":""
         },
         {
            "main":"Left Lateral Rotation",
            "dbqName":"form1[0].#subform[6].Right_InternalRotation3b[0]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }          
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain?",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
               {
                  "main":"Weight-bearing",
                  "dbqName":"form1[0].#subform[7].Weightbearing3b[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":""
               },
               {
                  "main":"Non-weight bearing",
                  "dbqName":"form1[0].#subform[7].Non-weightbearing3b[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":""
               },
               {
                  "main":"Active motion",
                  "dbqName":"form1[0].#subform[7].Activemotion3b[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":""
               },
               {
                  "main":"Passive motion",
                  "dbqName":"form1[0].#subform[7].Passivemotion3b[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":""
               },
               {
                  "main":"On Rest/Non-movement",
                  "dbqName":"form1[0].#subform[7].Onrestnon-movement3b[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":""
               },
               {
                  "main":"Causes functional loss",
                  "dbqName":"form1[0].#subform[7].Causesfunctional[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":"",
                  "textarea": true,
                  "maxLength": 670,
                  "textdbqName" : "form1[0].#subform[7].ExplainWhy3b[2]",
                  "placeholder": "describe in the functional loss",
                  "textAnswer": ""
               },
               {
                  "main":"Does not result in/cause functional loss",
                  "dbqName":"form1[0].#subform[7].Doesnot[0],form1[0].#subform[7].EvidencePainYesNo3[0]",
                  "answer":""
               },
               {
                  "main":"None",
                  "partialField": true,
                  "dbqName":"form1[0].#subform[7].EvidencePainYesNo3[1]",
                  "answer":""
               }            
            ],
            "answer":""
   },
   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].CrepitusYesNo3c[1]",
      "dbqName_no":"form1[0].#subform[7].CrepitusYesNo3c[0]",
      "answer":"",
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].YesNo103a2[1]",
      "dbqName_no":"form1[0].#subform[7].YesNo103a2[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "maxLength": 630,
      "placeholder": "Please describe location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[7].ExplainWhy3a4[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## have localized tenderness, guarding or muscle spasm of the thoracolumbar spine?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "presidence":"Yes",
      "ref":3,
      "dbqName_yes":"form1[0].#subform[9].Guarding_Spasms3g[1]",
      "dbqName_no":"form1[0].#subform[9].Guarding_Spasms3g[0]",
      "answer":"",
   },   
   {
   "question":"Localized tenderness",
   "sub":"",
   "type":"radioTiles",
   "multi": false,
   "show": false,
   "small": true,
   "refId":1,
   "cols": 2,
   "section": {
      page: "7",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3E"
   },
   "questions":[
            {
               "main":"None",
               "dbqName":"form1[0].#subform[9].Tenderness3g1[1]",
               "answer":""
            },
            {
               "main":"Not resulting in abnormal gait",
               "dbqName":"form1[0].#subform[9].Tenderness3g1[0]",
               "answer":"",
               "textarea": true,
               "maxLength": 510,
               "textdbqName" : "form1[0].#subform[9].Describe3g1[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            }          
         ],
         "answer":""
   },
   {
      "question":"If ##name## has ##redHeading## of the thoracolumbar spine, identify which (choose only one)",
      "redHeading":"muscle spasms",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "small": true,
      "refId":2,
      "cols": 2,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "questions":[
            {
               "main":"None",
               "dbqName":"form1[0].#subform[9].Spasm3g[0]",
               "answer":""
            },
            {
               "main":"Resulting in abnormal gait or abnormal spine contour",
               "dbqName":"form1[0].#subform[9].Spasm3g[1]",
               "answer":"",
               "textarea": true,
               "maxLength": 510,
               "textdbqName" : "form1[0].#subform[9].Describe3g2[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            },
            {
               "main":"Not resulting in abnormal gait or abnormal spinal contour",
               "dbqName":"form1[0].#subform[9].Spasm3g[2]",
               "answer":"",
               "textarea": true,
               "maxLength": 510,
               "textdbqName" : "form1[0].#subform[9].Describe3g2[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            },
            {
               "main":"Unable to evaluate, describe below",
               "dbqName":"form1[0].#subform[9].Spasm3g[3]",
               "answer":"",
               "textarea": true,
               "maxLength": 510,
               "textdbqName" : "form1[0].#subform[9].Describe3g2[0]",
               "placeholder": "Provide description and/or etiology",
               "textAnswer": ""
            }          
         ],
         "answer":""
   },
   {
      "question":"If ##name## has ##redHeading## of the thoracolumbar spine, identify which (choose only one)",
      "redHeading":"guarding",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": false,
      "small": true,
      "refId":3,
      "cols": 2,
      "section": {
         page: "8",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "questions":[
         {
            "main":"None",
            "dbqName":"form1[0].#subform[10].Guarding3g[0]",
            "answer":""
         },
         {
            "main":"Resulting in abnormal gait or abnormal spine contour",
            "dbqName":"form1[0].#subform[10].Guarding3g[1]",
            "answer":"",
            "textarea": true,
            "maxLength": 510,
            "textdbqName" : "form1[0].#subform[10].Describe3g3[0]",
            "placeholder": "Provide description and/or etiology",
            "textAnswer": ""
         },
         {
            "main":"Not resulting in abnormal gait or abnormal spinal contour",
            "dbqName":"form1[0].#subform[10].Guarding3g[2]",
            "answer":"",
            "textarea": true,
            "maxLength": 510,
            "textdbqName" : "form1[0].#subform[10].Describe3g3[0]",
            "placeholder": "Provide description and/or etiology",
            "textAnswer": ""
         },
         {
            "main":"Unable to evaluate, describe below",
            "dbqName":"form1[0].#subform[10].Guarding3g[3]",
            "answer":"",
            "textarea": true,
            "maxLength": 510,
            "textdbqName" : "form1[0].#subform[10].Describe3g3[0]",
            "placeholder": "Provide description and/or etiology",
            "textAnswer": ""
         }          
      ],
      "answer":""
   },
   {
      "question":"Rate Muscle Strength",
      "redHeading": "Right Side",
      "sub":"RATE STRENGTH ACCORDING TO THE FOLLOWING SCALE",
      "type":"select",
      "show": true,
      "section": {
         page: "8",
         title: "MUSCLE STRENGTH TESTING",
         number: "4A"
      },
      "questions":[
         {
            "label":"Flexion/Extension",
            "title":"Right Side",
            "subMain":"Rate Strength",
            "sub":"",
            "options":[
               {
                  "main":"Hip Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength1[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Knee Extension",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength3[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Ankle Plantar Flexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength4[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Ankle Dorsiflexion",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength5[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               },
               {
                  "main":"Great Toe Extension",
                  "sub":"",
                  "dbqName":"form1[0].#subform[10].Right_Strength8[0]",
                  "defaultVal": "5",
                  "values":[
                     "0",
                     "1",
                     "2",
                     "3",
                     "4",
                     "5"
                  ],
                  "answer":"5"
               }
            ]
         },
         {
         "label":"Flexion/Extension",
         "title":"Left Side",
         "subMain":"Rate Strength",
         "sub":"",
         "options":[
            {
               "main":"Hip Flexion",
               "sub":"",
               "dbqName":"form1[0].#subform[10].Left_Strength1[0]",
               "defaultVal": "5",
               "values":[
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
               ],
               "answer":"5"
            },
            {
               "main":"Knee Extension",
               "sub":"",
               "dbqName":"form1[0].#subform[10].Left_Strength3[0]",
               "defaultVal": "5",
               "values":[
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
               ],
               "answer":"5"
            },
            {
               "main":"Ankle Plantar Flexion",
               "sub":"",
               "dbqName":"form1[0].#subform[10].Left_Strength4[0]",
               "defaultVal": "5",
               "values":[
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
               ],
               "answer":"5"
            },
            {
               "main":"Ankle Dorsiflexion",
               "sub":"",
               "dbqName":"form1[0].#subform[10].Left_Strength5[0]",
               "defaultVal": "5",
               "values":[
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
               ],
               "answer":"5"
            },               
            {
               "main":"Great Toe Extension",
               "sub":"",
               "dbqName":"form1[0].#subform[10].Left_Strength8[0]",
               "defaultVal": "5",
               "values":[
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
               ],
               "answer":"5"
            }
         ]
         }         
      ],
      "rules": [
      {
         "label":"Muscle Strength-Rate Scale",
         "legend":"muscleStrengthScale",
         "title":".",
         "subMain":"",
         "sub":"",
         "options":[
            {
            "main":"No Muscle Movement",
            "sub":"0/5"
            },
            {
            "main":"Palpable or visible muscle contraction, but no joint movement",
            "sub":"1/5"
            },
            {
            "main":"Active Movement with Gravity Eliminated",
            "sub":"2/5"
            },
            {
            "main":"Active Movement Against Gravity",
            "sub":"3/5"
            },
            {
            "main":"Active Movement Against Some Resistance",
            "sub":"4/5"
            },
            {
            "main":"Normal Strength",
            "sub":"5/5"
            }
         ]
      }
      ]
   },
   {
      "question":"Rate Deep Tendon Reflexes",
      "redHeading": "Right Side",
      "sub":"RATE DEEP TENDON REFLEXES (DTRs) ACCORDING TO THE FOLLOWING SCALE",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "REFLEX EXAM",
         number: "5A"
      },
      "questions":[
         {
            "label":"Right Knee",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Knee[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Knee[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Knee[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive w/o Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Knee[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive w/ Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Knee[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         },
         {
            "label":"Right Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive w/o Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Right_Ankle[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         }
      ]
   },
   {
      "question":"Rate Deep Tendon Reflexes",
      "redHeading": "Left Side",
      "sub":"RATE DEEP TENDON REFLEXES (DTRs) ACCORDING TO THE FOLLOWING SCALE",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "SENSORY EXAM",
         number: "6A"
      },
      "questions":[
         {
            "label":"Left Knee",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Knee[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Knee[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Knee[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive w/o Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Knee[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive with Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Knee[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         },
         {
            "label":"Left Ankle",
            "title":"",
            "subMain":"",
            "sub":"",
            "defaultVal": "2+ Normal",
            "options":[
               {
                  "main":"0 Absent",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"1+ Hypoactive",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"2+ Normal",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"3+ Hyperactive w/o Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Ankle[0]",
                  "sub":""
               },
               {
                  "main":"4+ Hyperactive w/ Clonus",
                  "type":"text",
                  "dbqName":"form1[0].#subform[11].Left_Ankle[0]",
                  "sub":""
               }
            ],
            "answer":"2+ Normal"
         }
      ]
   },
   {
      "question":"Sensory Exam",
      "redHeading": "Right Side",
      "sub":" RESULTS FOR SENSATION TO LIGHT TOUCH (dermatome) TESTING",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "SENSORY EXAM",
         number: "6A"
      },
      "questions":[
         {
            "label":"Upper Anterior Thigh (L2)",
            "title":"Right Side",
            "subMain":"",
            "sub":"L2",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_UpperThigh[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_UpperThigh[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_UpperThigh[1]",
                  "sub":""
               },
            ],
            "answer":"Normal"
         },
         {
            "label":"Lower Leg/Ankle (L4/L5/S1)",
            "title":"Right Side",
            "subMain":"",
            "sub":"L4/L5/S1",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_LowerLeg[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_LowerLeg[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_LowerLeg[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Thigh/Knee (L3/4)",
            "title":"Right Side",
            "subMain":"",
            "sub":"L3/4",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_Thigh[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_Thigh[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_Thigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Foot/Toes (L5)",
            "title":"Right Side",
            "subMain":"",
            "sub":"L5",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Right_FootToes[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Right_FootToes[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Right_FootToes[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         }
      ]
   },
   {
      "question":"Sensory Exam",
      "redHeading": "Left Side",
      "sub":" RESULTS FOR SENSATION TO LIGHT TOUCH (dermatome) TESTING",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "SENSORY EXAM",
         number: "6A"
      },
      "questions":[
         {
            "label":"Upper Anterior Thigh (L2)",
            "title":"Left Side",
            "subMain":"",
            "sub":"L2",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_UpperThigh[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_UpperThigh[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_UpperThigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Lower Leg/Ankle (L4/L5/S1)",
            "title":"Left Side",
            "subMain":"",
            "sub":"L4/L5/S1",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_LowerLeg[0]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_LowerLeg[2]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_LowerLeg[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Thigh/Knee (L3/4)",
            "title":"Left Side",
            "subMain":"",
            "sub":"L3/4",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_Thigh[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_Thigh[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_Thigh[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         },
         {
            "label":"Foot/Toes (L5)",
            "title":"Left Side",
            "subMain":"",
            "sub":"L5",
            "defaultVal": "Normal",
            "options":[
               {
                  "main":"Normal",
                  "dbqName":"form1[0].#subform[11].Left_FootToes[2]",
                  "sub":""
               },
               {
                  "main":"Decreased",
                  "dbqName":"form1[0].#subform[11].Left_FootToes[0]",
                  "sub":""
               },
               {
                  "main":"Absent",
                  "dbqName":"form1[0].#subform[11].Left_FootToes[1]",
                  "sub":""
               }
            ],
            "answer":"Normal"
         }
      ]
   },

   {
      "question":"Provide straight leg raising test results for ##redHeading##",
      "redHeading":"Right side",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "small": true,
      "note": "This test can be performed with the Veteran seated or supine. Raise each straightened leg until pain begins, typically at 30-70 degrees of elevation. The test is positive if the pain radiates below the knee, not merely limited to the back or hamstring muscles. Pain is often increased on dorsiflexion of the foot, and relieved by knee flexion. A positive test suggests radiculopathy, often due to disc herniation.",
      "cols": 2,
      "section": {
         page: "10",
         title: "STRAIGHT LEG RAISING TEST",
         number: "7A"
      },
      "questions":[
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[12].StraightLeg_Right7[0]",
                  "answer":""
               },
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[12].StraightLeg_Right7[1]",
                  "answer":""
               },
               {
                  "main":"Unable to perform",
                  "dbqName":"form1[0].#subform[12].StraightLeg_Right7[2]",
                  "answer":"",
                  "textarea": true,
                  "maxLength": 440,
                  "textdbqName" : "form1[0].#subform[12].Comments[1]",
                  "placeholder": "Please explain",
                  "textAnswer": ""
               },            
            ],
            "answer":""
   },
   {
      "question":"Provide straight leg raising test results for ##redHeading##",
      "redHeading":"Left side",
      "sub":"",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "small": true,
      "note": "This test can be performed with the Veteran seated or supine. Raise each straightened leg until pain begins, typically at 30-70 degrees of elevation. The test is positive if the pain radiates below the knee, not merely limited to the back or hamstring muscles. Pain is often increased on dorsiflexion of the foot, and relieved by knee flexion. A positive test suggests radiculopathy, often due to disc herniation.",
      "cols": 2,
      "section": {
         page: "10",
         title: "STRAIGHT LEG RAISING TEST",
         number: "7A"
      },
      "questions":[
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[12].StraightLeg_Left7[0]",
                  "answer":""
               },
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[12].StraightLeg_Left7[1]",
                  "answer":""
               },
               {
                  "main":"Unable to perform",
                  "dbqName":"form1[0].#subform[12].StraightLeg_Left7[2]",
                  "answer":"",
                  "textarea": true,
                  "append": true,
                  "maxLength": 440,
                  "textdbqName" : "form1[0].#subform[12].Comments[1]",
                  "placeholder": "Please explain",
                  "textAnswer": ""
               },            
            ],
            "answer":""
   },
   
   {
      "question":"Does ##name## have radicular pain or any other signs or symptoms due to radiculopathy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "10",
         title: "RADICULOPATHY",
         number: "8A"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"form1[0].#subform[12].YesNo11[0]",
      "dbqName_no":"form1[0].#subform[12].YesNo11[1]",
      "answer":"",
   },
   {
      "question":"Radiculopathy for ##redHeading##",
      "redHeading":"Right Side",
      "sub":"Evaluate severity of radiculopathy by incorporating the effects of subjective symptoms (e.g ##name## indicates numbness, tingling, etc.) and objective findings",
      "type":"radio",
      "show": false,
      "refId":1,
      "srcMap": "radiculopathy1",
      "section": {
         page: "10",
         title: "RADICULOPATHY",
         number: "8A"
      },
      "questions":[
         {
            "label":"Constant pain",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Right_Severity1[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Right_Severity1[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Right_Severity1[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Right_Severity1[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Intermittent pain",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Right_Severity2[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Right_Severity2[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Right_Severity2[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Right_Severity2[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Paresthesias and/or dysesthesias",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Right_Severity4[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Right_Severity4[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Right_Severity4[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Right_Severity4[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Numbness",
            "title":"Right Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Right_Severity5[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Right_Severity5[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Right_Severity5[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Right_Severity5[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         }
      ]
   },
   {
      "question":"Radiculopathy for ##redHeading##",
      "redHeading":"Left Side",
      "sub":"Evaluate severity of radiculopathy by incorporating the effects of subjective symptoms (e.g ##name## indicates numbness, tingling, etc.) and objective findings",
      "type":"radio",
      "show": false,
      "refId":2,
      "srcMap": "radiculopathy1",
      "section": {
         page: "10",
         title: "RADICULOPATHY",
         number: "8A"
      },
      "questions":[
         {
            "label":"Constant pain",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Left_Severity1[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Left_Severity1[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Left_Severity1[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Left_Severity1[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Intermittent Pain",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Left_Severity2[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Left_Severity2[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Left_Severity2[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Left_Severity2[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Paresthesias and/or dysesthesias",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Left_Severity4[1]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Left_Severity4[2]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Left_Severity4[3]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Left_Severity4[0]",
                  "sub":""
               }
            ],
            "answer":"None"
         },
         {
            "label":"Numbness",
            "title":"Left Lower Extremity",
            "subMain":"",
            "sub":"",
            "defaultVal": "None",
            "options":[
               {
                  "main":"None",
                  "dbqName":"form1[0].#subform[12].Left_Severity5[2]",
                  "sub":""
               },
               {
                  "main":"Mild",
                  "dbqName":"form1[0].#subform[12].Left_Severity5[1]",
                  "sub":""
               },
               {
                  "main":"Moderate",
                  "dbqName":"form1[0].#subform[12].Left_Severity5[0]",
                  "sub":""
               },
               {
                  "main":"Severe",
                  "dbqName":"form1[0].#subform[12].Left_Severity5[3]",
                  "sub":""
               }
            ],
            "answer":"None"
         }
      ]
   },

   {
      "question":"Does ##name## have any other signs or symptoms for radiculopathy?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "10",
         title: "RADICULOPATHY",
         number: "8B"
      },
      "maxLength": 440,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[12].YesNo12[1]",
      "dbqName_no":"form1[0].#subform[12].YesNo12[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the signs or symptoms for radiculopathy",
      "textdbqName":"form1[0].#subform[12].Comments[0]",
      "textanswer":""
   }, 


   {
      "question":"Indicate nerve roots involved",
      "sub":"If yes, indicate side affected",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": true,
      "cols": 1,
      "partial": true,
      // "refId":1,
      "destMap": "radiculopathy1",
      "section": {
         page: "10",
         title: "RADICULOPATHY",
         number: "8C"
      },
      "questions":[
         {
            "main":"Involvement of L2/L3/L4 roots",
            "dbqName":"form1[0].#subform[12].NerveRoots[0]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"form1[0].#subform[12].SideAffected14[1]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"form1[0].#subform[12].SideAffected14[0]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"form1[0].#subform[12].SideAffected14[2]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Involvement of L4/L5/S1/S2/S3 roots",
            "dbqName":"form1[0].#subform[12].NerveRoots[2]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"form1[0].#subform[12].SideAffected15[1]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"form1[0].#subform[12].SideAffected15[2]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"form1[0].#subform[12].SideAffected15[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"Other nerves",
            "dbqName":"form1[0].#subform[12].NerveRoots[1]",
            "answer":"",
            "text1": "",
            "dbqName1": "form1[0].#subform[12].NerveRoot[0]",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Right",
                  "dbqName":"form1[0].#subform[12].SideAffected16[1]",
                  "answer":""
               },
               {
                  "main":"Left",
                  "dbqName":"form1[0].#subform[12].SideAffected16[0]",
                  "answer":""
               },
               {
                  "main":"Both",
                  "dbqName":"form1[0].#subform[12].SideAffected16[2]",
                  "answer":""
               }
            ],
         },
         {
            "main":"N/A",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":"N/A",
         },        
      ],
      "answer":""
   },

   {
      "question":"Does ##name## have any other neurologic abnormalities or findings related to a thoracolumbar spine condition?",
      "sub":"conditions such as bowel or bladder problems/pathologic reflexes",
      "type":"yesno",
      "show": true,
      "section": {
         page: "11",
         title: "OTHER NEUROLOGIC ABNORMALITIES",
         number: "10A"
      },
      "maxLength": 360,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[13].YesNo13A[1]",
      "dbqName_no":"form1[0].#subform[13].YesNo13A[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the condition and how it is related",
      "textdbqName":"form1[0].#subform[13].Comments[2]",
      "textanswer":""
   }, 
   {
      "question":"Regardless of ##name##'s current employment status, do the conditions listed in the diagnosis section impact his/her ability to perform any type of occupational task?",
      "sub":"Tasks such as standing, walking, lifting, sitting etc.",
      "type":"yesno",
      "show": true,
      "section": {
         page: "14",
         title: "FUNCTIONAL IMPACT",
         number: "16A"
      },
      "maxLength": 890,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[16].YesNo24[1]",
      "dbqName_no":"form1[0].#subform[16].YesNo24[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the condition and how it is related",
      "textdbqName":"form1[0].#subform[16].Comments6[0]",
      "textanswer":""
   }, 
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":1250,
      "show": true,
      "section": {
         page: "14",
         title: "REMARKS",
         number: "17A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[16].Comments[10]",
      "answer":""
   },
]
   
   export default back_questions ;
